import React from 'react';

const testimonials = [
    {
        quote: "OmniTrace transformed our quality control. We can now perform audits in minutes that used to take days of searching through paperwork.",
        author: "Sarah Jenkins",
        role: "Production Manager at NatureGrow",
        avatar: "https://i.pravatar.cc/150?u=sarah"
    },
    {
        quote: "The real-time inventory tracking saved us over $20k in wastage last quarter alone. Essential tool for any modern factory.",
        author: "Michael Chen",
        role: "COO of Global Logistics",
        avatar: "https://i.pravatar.cc/150?u=michael"
    },
    {
        quote: "Finally, an ERP that doesn't feel like it's from the 90s. Clean, fast, and incredibly powerful data visualizations.",
        author: "David Ross",
        role: "Head of Operations, FreshCo",
        avatar: "https://i.pravatar.cc/150?u=david"
    }
];

const Testimonials = () => {
    return (
        <section className="py-8 bg-slate-50 overflow-hidden">
            <div className="section-padding">
                <h2 className="heading-lg text-center mb-10">Trusted by Industry Leaders</h2>

                <div className="grid md:grid-cols-3 gap-6">
                    {testimonials.map((t, i) => (
                        <div key={i} className="bg-white p-8 rounded-2xl border border-slate-100 shadow-sm relative">
                            <div className="text-sky-400 absolute top-4 right-8 text-6xl font-serif opacity-20">"</div>
                            <p className="text-slate-700 text-lg italic mb-8 relative z-10">
                                {t.quote}
                            </p>
                            <div className="flex items-center gap-4">
                                <img src={t.avatar} alt={t.author} className="w-12 h-12 rounded-full" />
                                <div>
                                    <h4 className="font-bold text-slate-900">{t.author}</h4>
                                    <p className="text-sm text-slate-500">{t.role}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-20 flex flex-wrap justify-center items-center gap-12 opacity-50 grayscale">
                    {['TECHCORP', 'FOODLOGIC', 'FASTMAN', 'SUREPACK', 'GREENBELT'].map((logo, i) => (
                        <span key={i} className="text-2xl font-black text-slate-400 tracking-widest">{logo}</span>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
